<template>
  <section
    class="w-100 h-100 aspect-ratio-container"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <div :class=" ['outer-color w-100 h-100',
      hovering ? '' : 'card-text-shadow']"
    >
      <v-img
        width="100%"
        height="100%"
        :eager="true"
        :src="event.image"
        :lazy-src="require('../assets/no-image-selected.jpg')"
        :class=" ['card-image',  hovering ? 'card-image-hover' : 'card-text-shadow']"
      />

      <span class="card-time">
        <span class="start-time">{{ startTime }}</span>
        <span class="end-time"> - {{ endTime }}</span>
      </span>
      <span class="card-date">
        <span class="card-date-number">
          {{ startDay }}
        </span>
        <span class="card-date-month">
          {{ startMonth }}
        </span>
      </span>

      <span class="card-title">
        {{ event.title }}
      </span>

      <span class="card-blurb">
        {{ cardBlurb }}
      </span>
    </div>

  </section>
</template>

<script>
import { format } from "date-fns";

export default {
  name: 'eventCard',
  components: {},
  props: {
    event: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      hovering: false,
    }
  },
  computed: {
    backgroundStyle() {
      return {
        "background-image": this.event.image,
      }
    },
    cardBlurb() {
      if (this.event.shortDescription.length > 68)
        return this.event.shortDescription.substring(0, 65) + '...'
      else
        return this.event.shortDescription
    },
    startTime() {
      return format(this.event.startDate, 'hh:mm a');
    },
    endTime() {
      return format(this.event.endDate, 'hh:mm a');
    },
    startDay() {
      return format(this.event.startDate, 'dd');
    },
    startMonth() {
      return format(this.event.startDate, 'MMM');
    },
  },
}
</script>
<style scoped>
.outer-color {
  background-color: #1c1c1c;
  color: white;
  cursor: pointer;
  font-size: 22px;
  position: absolute;
  top: 0;
  left: 0;
}

.card-time {
  position: absolute;
  font-size: 21px;
  left: 5px;
  top: 20px;
}

.card-text-shadow {
  text-shadow: 2px 2px #000000 !important;
}

.end-time {
  font-size: 12px;
}

.card-date {
  position: absolute;
  right: 5px;
  top: 3px;
}

.card-date-number {
  font-size: 26px;
}

.card-date-month {
  font-size: 11px;
  position: absolute;
  top: 29px;
  right: 3px;
}

.card-image {
  transition: .33s ease;
  filter: blur(0.03em);
  -webkit-filter: blur(0.03em);
  opacity: .85;
  transform: scale(1.02);
}

.card-image-hover {
  opacity: .20;
  filter: blur(3px);
  -webkit-filter: blur(3px);
  transform: scale(1.1);
}

.card-title {
  position: absolute;
  font-size: 16pt;
  font-weight: bold;
  text-transform: uppercase;
  top: 37%;
  right: 10px;
  left: 10px;
  line-height: 90%;
}

.card-blurb {
  position: absolute;
  left: 10px;
  right: 15px;
  bottom: 14px;
  font-size: 13px;
  text-transform: none;
  max-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(255, 255, 255, 0.92);
}

.aspect-ratio-container {
  position: relative;
  width: 100%;
  padding-top: 125%;
  overflow: hidden;
}

.blur-image {
  /* Add the blur effect */
  filter: blur(8px);
  -webkit-filter: blur(8px);
}

</style>
